<div class="box-dialog-wrapper">
  <header #dialogHeader class="box-dialog-header">
    <box-dialog-header [title]="'my_addresses'" (closeDialog)="closeDialog()"></box-dialog-header>
  </header>
  <main #dialogBody bodyScroll class="box-dialog-content" (bodyScroll)="onBodyScroll($event)">
    <div class="addresses-wrapper">
      <ng-container *ngIf="addresses?.length > 0; else emptyState">
        <div class="addresses-container">
          <mat-radio-group aria-label="Select an address">
            <mat-radio-button
              *ngFor="let address of addresses"
              color="primary"
              class="box-radio-button addresses-radio-button hoverable"
              [value]="address"
              [checked]="areAddressesEqual(address, currentAddress)"
              (keydown.enter)="onAddressSelect(address)"
              (keydown.space)="onAddressSelect(address)"
              (click)="onAddressClick($event, address)"
            >
              <address [address]="address"></address>
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </ng-container>
      <ng-template #emptyState>
        <div class="addresses-empty-state">
          <figure class="image contain-image empty-state-image">
            <img src="/assets/images/empty-state/scooter-empty-state.svg" alt="Scooter empty state" />
          </figure>
        </div>
        <h4 class="empty-state-title">{{ 'where_shoud_we_bring' | translate }}</h4>
        <div class="addresses-instructions">{{ 'insert_address_text' | translate }}</div>
      </ng-template>
    </div>
  </main>
  <footer #dialogFooter class="box-dialog-footer">
    <div class="footer-btn-wrapper">
      <button box-button theme="primary" type="button" (click)="addAddress()">
        {{ 'add_new_address' | translate }}
      </button>
    </div>
  </footer>
</div>
